const { appApiUrl } = require('./api-url');

async function loadTermsAcceptance(user) {
  const token = await user.getIdToken();
  const response = await fetch(`${appApiUrl}/api/account/terms-acceptance`, {
    headers: { authorization: `Bearer ${token}` }
  });
  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.error || 'Unable to check the terms and conditions');
  }

  return result;
}

async function acceptAccountTerms(user, termsVersion) {
  const token = await user.getIdToken();
  const response = await fetch(`${appApiUrl}/api/account/terms-acceptance`, {
    method: 'POST',
    headers: {
      authorization: `Bearer ${token}`,
      'content-type': 'application/json'
    },
    body: JSON.stringify({ termsVersion })
  });
  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.error || 'Unable to accept the terms and conditions');
  }

  return result;
}

module.exports = { acceptAccountTerms, loadTermsAcceptance };
